/**
 * Phase 1 spine — risks + issues for the RiskIssueList widget.
 *
 * Two list queries (risks, issues) combined into one ergonomic return. Kept in
 * the widgets layer (not imported from the Risk page hooks) so the shared
 * widget doesn't depend on a page module.
 */ import { useQuery } from '@tanstack/react-query';
import { deliveryClient } from '../../../lib/connect/clients';
export const PROGRAM_RISKS_KEY = 'program risks';
export const PROGRAM_ISSUES_KEY = 'program issues';
export function useProgramRisksIssues(programId) {
    const risks = useQuery({
        queryKey: [
            PROGRAM_RISKS_KEY,
            programId
        ],
        queryFn: async ()=>(await deliveryClient.listRisks({
                programId: programId ?? ''
            })).risks,
        enabled: !!programId,
        staleTime: 30000
    });
    const issues = useQuery({
        queryKey: [
            PROGRAM_ISSUES_KEY,
            programId
        ],
        queryFn: async ()=>(await deliveryClient.listIssues({
                programId: programId ?? ''
            })).issues,
        enabled: !!programId,
        staleTime: 30000
    });
    return {
        risks: risks.data ?? [],
        issues: issues.data ?? [],
        isLoading: risks.isLoading || issues.isLoading,
        isError: risks.isError || issues.isError
    };
}
